function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 33C25.04 33 27.5 30.54 27.5 27.5V16H26V27.5C26 29.71 24.21 31.5 22 31.5C19.79 31.5 18 29.71 18 27.5V15C18 14.337 18.2634 13.7011 18.7322 13.2322C19.2011 12.7634 19.837 12.5 20.5 12.5C21.163 12.5 21.7989 12.7634 22.2678 13.2322C22.7366 13.7011 23 14.337 23 15V25.5C23 26.05 22.55 26.5 22 26.5C21.45 26.5 21 26.05 21 25.5V16H19.5V25.5C19.5 26.163 19.7634 26.7989 20.2322 27.2678C20.7011 27.7366 21.337 28 22 28C22.663 28 23.2989 27.7366 23.7678 27.2678C24.2366 26.7989 24.5 26.163 24.5 25.5V15C24.5 12.79 22.71 11 20.5 11C18.29 11 16.5 12.79 16.5 15V27.5C16.5 30.54 18.96 33 22 33Z",
  fill: "#4D4D4D"
});

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.69511feb.svg";
export { ForwardRef as ReactComponent };